module.exports = __webpack_public_path__ + "static/img/TJ.6ba79f8f.svg";